import React from "react";
import contextProvider from "../../../contextProvider";
import { Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";
import ReactOTable from "../../../_L1_components/Elements/ReactOTable";
import ReactOCollapse from "../../../_L1_components/Elements/ReactOCollapse";
import Section from "../../../_L1_components/Layout/Section";
import Panel from "../../../_L1_components/Layout/Panel";
import ReactOForm from "../../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../../_L1_components/Elements/ReactOFormInput";
import RowSpanTableDiag from "../../Elements/RowSpanTableDiag";

const context_exposed_methods = [];

class DiagView extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: null,
      infoText: false,
      _advanced_collapse_opened2: false,
    };
    super(props, initState);

    this.apiStore = null;
    this.actionsShelf = null;
    this._essid_sorting = "asc";
    this._autorefresh = null;
    this.urlParams = new URLSearchParams(window.location.search);
  }

  onComponentDidMount() {
    this.mounted = true;
    this.getAppContext().getLocalStorageService().remove("measure_graph_view");
    this.getAppContext().getLocalStorageService().remove("measure_graph_view");
    this.apiStore = this.getAppContext().getApiStoreService();
    this.actionsShelf = this.getAppContext().getActionsShelfService();
    const ts = this.urlParams.get("ts");
    if (ts) {
      let infoText = false;
      const now = this.getAppContext().momentjs().unix();
      const diff = now - ts;
      if (diff > 900) {
        infoText = this.makeInfoText(diff);
      }
      this.setState({ infoText }, () => {
        this.loadDiag();
        this._reload_form.init();
      });
    } else {
      this.loadDiag();
      this._reload_form.init();
    }
  }

  countOfflineProbes(data) {
    let filtered = data.filter((d) => d.sync_status == 0);
    return filtered.length;
  }

  checkOpen(t, count) {
    // ts={TS_NOW}&tab=diag&line=1

    const line = this.urlParams.get("line");
    if (line && line == t) {
      return true;
    } else if (!line && count && count < 4) {
      return true;
    } else {
      return false;
    }
  }

  loadDiag(refresh) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("dashboard_diag", {
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this._rowSpanWorking = {
                probe: {},
                essid: {},
                ap: {},
                diag: {},
                label: {},
                measureName: {},
              };

              data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "success";
                })
                .forEach((elem) => {
                  this._rowSpanWorking.probe[
                    elem.probename.replace(/['"]+/g, "").trim()
                  ] =
                    (this._rowSpanWorking.probe[
                      elem.probename.replace(/['"]+/g, "").trim()
                    ] || 0) + 1;
                  this._rowSpanWorking.essid[elem.essid] =
                    (this._rowSpanWorking.essid[elem.essid] || 0) + 1;
                  this._rowSpanWorking.ap[elem.ap_name] =
                    (this._rowSpanWorking.ap[elem.ap_name] || 0) + 1;
                  this._rowSpanWorking.diag[elem.diag] =
                    (this._rowSpanWorking.diag[elem.diag] || 0) + 1;
                  this._rowSpanWorking.label[elem.label] =
                    (this._rowSpanWorking.label[elem.label] || 0) + 1;
                  this._rowSpanWorking.measureName[elem.name] =
                    (this._rowSpanWorking.measureName[elem.name] || 0) + 1;
                });

              this._rowSpanAnomalies = {
                probe: {},
                essid: {},
                ap: {},
                diag: {},
                label: {},
                measureName: {},
              };

              data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "danger" && _C_online0.diag != "N";
                })
                .forEach((elem) => {
                  this._rowSpanAnomalies.probe[
                    elem.probename.replace(/['"]+/g, "").trim()
                  ] =
                    (this._rowSpanAnomalies.probe[
                      elem.probename.replace(/['"]+/g, "").trim()
                    ] || 0) + 1;
                  this._rowSpanAnomalies.essid[elem.essid] =
                    (this._rowSpanAnomalies.essid[elem.essid] || 0) + 1;
                  this._rowSpanAnomalies.ap[elem.ap_name] =
                    (this._rowSpanAnomalies.ap[elem.ap_name] || 0) + 1;
                  this._rowSpanAnomalies.diag[elem.diag] =
                    (this._rowSpanAnomalies.diag[elem.diag] || 0) + 1;
                  this._rowSpanAnomalies.label[elem.label] =
                    (this._rowSpanAnomalies.label[elem.label] || 0) + 1;
                  this._rowSpanAnomalies.measureName[elem.name] =
                    (this._rowSpanAnomalies.measureName[elem.name] || 0) + 1;
                });

              this._rowSpanNotEnough = {
                probe: {},
                essid: {},
                ap: {},
                diag: {},
                label: {},
                measureName: {},
              };

              data.online
                .filter((_C_online0) => {
                  return _C_online0.diag == "N";
                })
                .forEach((elem) => {
                  this._rowSpanNotEnough.probe[
                    elem.probename.replace(/['"]+/g, "").trim()
                  ] =
                    (this._rowSpanNotEnough.probe[
                      elem.probename.replace(/['"]+/g, "").trim()
                    ] || 0) + 1;
                  this._rowSpanNotEnough.essid[elem.essid] =
                    (this._rowSpanNotEnough.essid[elem.essid] || 0) + 1;
                  this._rowSpanNotEnough.ap[elem.ap_name] =
                    (this._rowSpanNotEnough.ap[elem.ap_name] || 0) + 1;
                  this._rowSpanNotEnough.diag[elem.diag] =
                    (this._rowSpanNotEnough.diag[elem.diag] || 0) + 1;
                  this._rowSpanNotEnough.label[elem.label] =
                    (this._rowSpanNotEnough.label[elem.label] || 0) + 1;
                  this._rowSpanNotEnough.measureName[elem.name] =
                    (this._rowSpanNotEnough.measureName[elem.name] || 0) + 1;
                });

              // ANOMALIES COUNT

              this._anomaliesCount = data.online.filter((_C_online0) => {
                return _C_online0.color == "danger" && _C_online0.diag != "N";
              }).length;
              this._countProbAnomalies = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "danger" && _C_online0.diag != "N";
                })
                .reduce((sums, entry) => {
                  sums[entry.probeid] = (sums[entry.probeid] || 0) + 1;
                  return sums;
                }, {});

              this._countEssidAnomalies = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "danger" && _C_online0.diag != "N";
                })
                .reduce((sums, entry) => {
                  sums[entry.essid] = (sums[entry.essid] || 0) + 1;
                  return sums;
                }, {});

              this._countAPsAnomalies = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "danger" && _C_online0.diag != "N";
                })
                .reduce((sums, entry) => {
                  sums[entry.ap_name] = (sums[entry.ap_name] || 0) + 1;
                  return sums;
                }, {});

              this._countLabelAnomalies = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "danger" && _C_online0.diag != "N";
                })
                .reduce((sums, entry) => {
                  sums[entry.label] = (sums[entry.label] || 0) + 1;
                  return sums;
                }, {});

              this._countMeasureNameAnomalies = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "danger" && _C_online0.diag != "N";
                })
                .reduce((sums, entry) => {
                  sums[entry.name] = (sums[entry.name] || 0) + 1;
                  return sums;
                }, {});

              // NOT ENOUGH COUNT

              this._notEnoughCount = data.online.filter((_C_online0) => {
                return (
                  _C_online0.diag == "N" && _C_online0.explicit_mac == "yes"
                );
              }).length;

              this._countProbNotEnough = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "yes"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.probeid] = (sums[entry.probeid] || 0) + 1;
                  return sums;
                }, {});

              this._countEssidNotEnough = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "yes"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.essid] = (sums[entry.essid] || 0) + 1;
                  return sums;
                }, {});

              this._countApsNotEnough = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "yes"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.ap_name] = (sums[entry.ap_name] || 0) + 1;
                  return sums;
                }, {});

              this._countLabelNotEnough = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "yes"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.label] = (sums[entry.label] || 0) + 1;
                  return sums;
                }, {});

              this._countMeasureNameNotEnough = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "yes"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.name] = (sums[entry.name] || 0) + 1;
                  return sums;
                }, {});

              // NOT ENOUGHT NOT EXPLICIT MAC

              this._notEnoughCount_ex = data.online.filter((_C_online0) => {
                return (
                  _C_online0.diag == "N" && _C_online0.explicit_mac == "no"
                );
              }).length;

              this._countProbNotEnough_ex = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "no"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.probeid] = (sums[entry.probeid] || 0) + 1;
                  return sums;
                }, {});

              this._countProbNotEnough_ex = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "no"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.essid] = (sums[entry.essid] || 0) + 1;
                  return sums;
                }, {});

              this._countApsNotEnough_ex = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "no"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.ap_name] = (sums[entry.ap_name] || 0) + 1;
                  return sums;
                }, {});

              this._countLabelNotEnough_ex = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "no"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.label] = (sums[entry.label] || 0) + 1;
                  return sums;
                }, {});

              this._countProbNotEnough_ex = data.online
                .filter((_C_online0) => {
                  return (
                    _C_online0.diag == "N" && _C_online0.explicit_mac == "no"
                  );
                })
                .reduce((sums, entry) => {
                  sums[entry.name] = (sums[entry.name] || 0) + 1;
                  return sums;
                }, {});

              // WORKING COUNT

              this._workingCount = data.online.filter((_C_online0) => {
                return _C_online0.color == "success";
              }).length;
              this._countProbWorking = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "success";
                })
                .reduce((sums, entry) => {
                  sums[entry.probeid] = (sums[entry.probeid] || 0) + 1;
                  return sums;
                }, {});

              this._countEssidWorking = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "success";
                })
                .reduce((sums, entry) => {
                  sums[entry.essid] = (sums[entry.essid] || 0) + 1;
                  return sums;
                }, {});

              this._countAPsWorking = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "success";
                })
                .reduce((sums, entry) => {
                  sums[entry.ap_name] = (sums[entry.ap_name] || 0) + 1;
                  return sums;
                }, {});
              this._countLabelWorking = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "success";
                })
                .reduce((sums, entry) => {
                  sums[entry.label] = (sums[entry.label] || 0) + 1;
                  return sums;
                }, {});

              this._countMeasureNameWorking = data.online
                .filter((_C_online0) => {
                  return _C_online0.color == "success";
                })
                .reduce((sums, entry) => {
                  sums[entry.name] = (sums[entry.name] || 0) + 1;
                  return sums;
                }, {});

              this.setState(
                {
                  data: data,
                  loading: false,
                },
                () => {
                  if (refresh) {
                    this._autorefresh = setInterval(() => {
                      this.loadDiag();
                    }, 120000);
                  }
                },
              );

              if (this.getAppContext().platformName() == "WiFiProbe") {
                this.formatTableForProbe(data.online);
              } else {
                this.formatTableForProbeNet(data.online);
              }
            }
          },
        });
      },
    );
  }

  formatTableForAp(data) {
    let rawDataWorking = data.filter((_C_online0) => {
      return _C_online0.color == "success";
    });

    let rawDataAnomalies = data.filter((_C_online0) => {
      return _C_online0.color == "danger" && _C_online0.diag != "N";
    });

    let rawDataNotEnough = data.filter((_C_online0) => {
      return _C_online0.diag == "N";
    });

    let sortByApWorking = {};
    let sortByApAnomalies = {};
    let sortByApNotEnough = {};
    Object.keys(this._rowSpanAnomalies.ap)
      .sort()
      .forEach((ap, id) => {
        sortByApAnomalies[ap] = {};

        let _filterAp = rawDataAnomalies.filter((_C_online0) => {
          return _C_online0.ap_name.replace(/['"]+/g, "").trim() == ap;
        });

        Object.keys(this._rowSpanAnomalies.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterProbe = _filterAp.filter((_C_online0) => {
              return _C_online0.probename.trim() == probename;
            });
            if (_filterProbe.length > 0) {
              sortByApAnomalies[ap][probename] = [];

              Object.keys(this._rowSpanAnomalies.essid)
                .sort()
                .forEach((essid) => {
                  let _filterEssid = _filterProbe.filter((_C_online0) => {
                    return _C_online0.essid == essid;
                  });

                  if (_filterEssid.length > 0) {
                    _filterEssid.forEach((row) => {
                      sortByApAnomalies[ap][probename].push(row);
                    });
                  }
                });
            }
          });
      });
    Object.keys(this._rowSpanNotEnough.ap)
      .sort()
      .forEach((ap, id) => {
        sortByApNotEnough[ap] = {};

        let _filterAp = rawDataNotEnough.filter((_C_online0) => {
          return _C_online0.ap_name.replace(/['"]+/g, "").trim() == ap;
        });
        Object.keys(this._rowSpanNotEnough.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterProbe = _filterAp.filter((_C_online0) => {
              return _C_online0.probename.trim() == probename;
            });
            if (_filterProbe.length > 0) {
              sortByApNotEnough[ap][probename] = [];
              Object.keys(this._rowSpanNotEnough.essid)
                .sort()
                .forEach((essid) => {
                  let _filterEssid = _filterProbe.filter((_C_online0) => {
                    return _C_online0.essid == essid;
                  });

                  if (_filterEssid.length > 0) {
                    _filterEssid.forEach((row) => {
                      sortByApNotEnough[ap][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanWorking.ap)
      .sort()
      .forEach((ap, id) => {
        sortByApWorking[ap] = {};

        let _filterAp = rawDataWorking.filter((_C_online0) => {
          return _C_online0.ap_name.replace(/['"]+/g, "").trim() == ap;
        });

        Object.keys(this._rowSpanWorking.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterProbe = _filterAp.filter((_C_online0) => {
              return _C_online0.probename.trim() == probename;
            });
            if (_filterProbe.length > 0) {
              sortByApWorking[ap][probename] = [];

              Object.keys(this._rowSpanWorking.essid)
                .sort()
                .forEach((essid) => {
                  let _filterEssid = _filterProbe.filter((_C_online0) => {
                    return _C_online0.essid == essid;
                  });

                  if (_filterEssid.length > 0) {
                    _filterEssid.forEach((row) => {
                      sortByApWorking[ap][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    this._sortMode = "ap";

    this.setState({
      sortByProbeWorking: null,
      sortByAnomalies: null,
      sortByNotEnough: null,

      sortByEssidWorking: null,
      sortByEssidAnomalies: null,
      sortByEssidNotEnough: null,

      sortByLabelWorking: null,
      sortByLabelAnomalies: null,
      sortByLabelNotEnough: null,

      sortByMeasureNameWorking: null,
      sortByMeasureNameAnomalies: null,
      sortByMeasureNameNotEnough: null,

      sortByProbeWorking_net: null,
      sortByAnomalies_net: null,
      sortByNotEnough_net: null,

      sortByApWorking: sortByApWorking,
      sortByApAnomalies: sortByApAnomalies,
      sortByApNotEnough: sortByApNotEnough,
    });
  }

  formatTableForEssid(data) {
    let rawDataWorking = data.filter((_C_online0) => {
      return _C_online0.color == "success";
    });

    let rawDataAnomalies = data.filter((_C_online0) => {
      return _C_online0.color == "danger" && _C_online0.diag != "N";
    });

    let rawDataNotEnough = data.filter((_C_online0) => {
      return _C_online0.diag == "N";
    });

    let sortByEssidWorking = {};
    let sortByEssidAnomalies = {};
    let sortByEssidNotEnough = {};

    Object.keys(this._rowSpanNotEnough.essid)
      .sort()
      .forEach((essid, id) => {
        sortByEssidNotEnough[essid] = {};

        let _filterProbe = rawDataNotEnough.filter((_C_online0) => {
          return _C_online0.essid == essid;
        });

        Object.keys(this._rowSpanNotEnough.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterEssid = _filterProbe.filter((_C_online0) => {
              return (
                _C_online0.probename.replace(/['"]+/g, "").trim() == probename
              );
            });
            if (_filterEssid.length > 0) {
              sortByEssidNotEnough[essid][probename] = [];

              Object.keys(this._rowSpanNotEnough.ap)
                .sort()
                .forEach((ap_name) => {
                  let _filterAp = _filterEssid.filter((_C_online0) => {
                    return _C_online0.ap_name == ap_name;
                  });

                  if (_filterAp.length > 0) {
                    _filterAp.forEach((row) => {
                      sortByEssidNotEnough[essid][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanAnomalies.essid)
      .sort()
      .forEach((essid, id) => {
        sortByEssidAnomalies[essid] = {};

        let _filterProbe = rawDataAnomalies.filter((_C_online0) => {
          return _C_online0.essid == essid;
        });

        Object.keys(this._rowSpanAnomalies.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterEssid = _filterProbe.filter((_C_online0) => {
              return (
                _C_online0.probename.replace(/['"]+/g, "").trim() == probename
              );
            });
            if (_filterEssid.length > 0) {
              sortByEssidAnomalies[essid][probename] = [];

              Object.keys(this._rowSpanAnomalies.ap)
                .sort()
                .forEach((ap_name) => {
                  let _filterAp = _filterEssid.filter((_C_online0) => {
                    return _C_online0.ap_name == ap_name;
                  });

                  if (_filterAp.length > 0) {
                    _filterAp.forEach((row) => {
                      sortByEssidAnomalies[essid][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanWorking.essid)
      .sort()
      .forEach((essid, id) => {
        sortByEssidWorking[essid] = {};

        let _filterProbe = rawDataWorking.filter((_C_online0) => {
          return _C_online0.essid == essid;
        });

        Object.keys(this._rowSpanWorking.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterEssid = _filterProbe.filter((_C_online0) => {
              return (
                _C_online0.probename.replace(/['"]+/g, "").trim() == probename
              );
            });
            if (_filterEssid.length > 0) {
              sortByEssidWorking[essid][probename] = [];

              Object.keys(this._rowSpanWorking.ap)
                .sort()
                .forEach((ap_name) => {
                  let _filterAp = _filterEssid.filter((_C_online0) => {
                    return _C_online0.ap_name == ap_name;
                  });

                  if (_filterAp.length > 0) {
                    _filterAp.forEach((row) => {
                      sortByEssidWorking[essid][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    this._sortMode = "essid";

    this.setState({
      sortByProbeWorking: null,
      sortByAnomalies: null,
      sortByNotEnough: null,

      sortByApWorking: null,
      sortByApAnomalies: null,
      sortByApNotEnough: null,

      sortByLabelWorking: null,
      sortByLabelAnomalies: null,
      sortByLabelNotEnough: null,

      sortByMeasureNameWorking: null,
      sortByMeasureNameAnomalies: null,
      sortByMeasureNameNotEnough: null,

      sortByProbeWorking_net: null,
      sortByAnomalies_net: null,
      sortByNotEnough_net: null,

      sortByEssidWorking: sortByEssidWorking,
      sortByEssidAnomalies: sortByEssidAnomalies,
      sortByEssidNotEnough: sortByEssidNotEnough,
    });
  }

  formatTableForProbe(data) {
    this._sortMode = "probe";

    let rawDataWorking = data.filter((_C_online0) => {
      return _C_online0.color == "success";
    });

    let rawDataAnomalies = data.filter((_C_online0) => {
      return _C_online0.color == "danger" && _C_online0.diag != "N";
    });

    let rawDataNotEnough = data.filter((_C_online0) => {
      return _C_online0.diag == "N";
    });

    let sortByProbeWorking = {};
    let sortByAnomalies = {};
    let sortByNotEnough = {};

    Object.keys(this._rowSpanWorking.probe)
      .sort()
      .forEach((probename, id) => {
        sortByProbeWorking[probename] = {};

        let _filterProbe = rawDataWorking.filter((_C_online0) => {
          return _C_online0.probename.replace(/['"]+/g, "").trim() == probename;
        });

        Object.keys(this._rowSpanWorking.essid)
          .sort()
          .forEach((essid, id2) => {
            let _filterEssid = _filterProbe.filter((_C_online0) => {
              return _C_online0.essid == essid;
            });
            if (_filterEssid.length > 0) {
              sortByProbeWorking[probename][essid] = [];

              Object.keys(this._rowSpanWorking.ap)
                .sort()
                .forEach((ap_name) => {
                  let _filterAp = _filterEssid.filter((_C_online0) => {
                    return _C_online0.ap_name == ap_name;
                  });

                  if (_filterAp.length > 0) {
                    _filterAp.forEach((row) => {
                      sortByProbeWorking[probename][essid].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanAnomalies.probe)
      .sort()
      .forEach((probename, id) => {
        sortByAnomalies[probename] = {};

        let _filterProbe = rawDataAnomalies.filter((_C_online0) => {
          return _C_online0.probename.replace(/['"]+/g, "").trim() == probename;
        });

        Object.keys(this._rowSpanAnomalies.essid)
          .sort()
          .forEach((essid, id2) => {
            let _filterEssid = _filterProbe.filter((_C_online0) => {
              return _C_online0.essid == essid;
            });
            if (_filterEssid.length > 0) {
              sortByAnomalies[probename][essid] = [];

              Object.keys(this._rowSpanAnomalies.ap)
                .sort()
                .forEach((ap_name) => {
                  let _filterAp = _filterEssid.filter((_C_online0) => {
                    return _C_online0.ap_name == ap_name;
                  });

                  if (_filterAp.length > 0) {
                    _filterAp.forEach((row) => {
                      sortByAnomalies[probename][essid].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanNotEnough.probe)
      .sort()
      .forEach((probename, id) => {
        sortByNotEnough[probename] = {};

        let _filterProbe = rawDataNotEnough.filter((_C_online0) => {
          return _C_online0.probename.replace(/['"]+/g, "").trim() == probename;
        });

        Object.keys(this._rowSpanNotEnough.essid)
          .sort()
          .forEach((essid, id2) => {
            let _filterEssid = _filterProbe.filter((_C_online0) => {
              return _C_online0.essid == essid;
            });
            if (_filterEssid.length > 0) {
              sortByNotEnough[probename][essid] = [];

              Object.keys(this._rowSpanNotEnough.ap)
                .sort()
                .forEach((ap_name) => {
                  let _filterAp = _filterEssid.filter((_C_online0) => {
                    return _C_online0.ap_name == ap_name;
                  });

                  if (_filterAp.length > 0) {
                    _filterAp.forEach((row) => {
                      sortByNotEnough[probename][essid].push(row);
                    });
                  }
                });
            }
          });
      });

    this.setState({
      sortByEssidWorking: null,
      sortByEssidAnomalies: null,
      sortByEssidNotEnough: null,

      sortByApWorking: null,
      sortByApAnomalies: null,
      sortByApNotEnough: null,

      sortByLabelWorking: null,
      sortByLabelAnomalies: null,
      sortByLabelNotEnough: null,

      sortByMeasureNameWorking: null,
      sortByMeasureNameAnomalies: null,
      sortByMeasureNameNotEnough: null,

      sortByProbeWorking_net: null,
      sortByAnomalies_net: null,
      sortByNotEnough_net: null,

      sortByProbeWorking: sortByProbeWorking,
      sortByAnomalies: sortByAnomalies,
      sortByNotEnough: sortByNotEnough,
    });
    // console.log(sortByAnomalies);
  }

  formatTableForProbeNet(data) {
    this._sortMode = "probe";

    let rawDataWorking = data.filter((_C_online0) => {
      return _C_online0.color == "success";
    });

    let rawDataAnomalies = data.filter((_C_online0) => {
      return _C_online0.color == "danger" && _C_online0.diag != "N";
    });

    let rawDataNotEnough = data.filter((_C_online0) => {
      return _C_online0.diag == "N";
    });

    let sortByProbeWorking_net = {};
    let sortByAnomalies_net = {};
    let sortByNotEnough_net = {};

    Object.keys(this._rowSpanWorking.probe)
      .sort()
      .forEach((probename, id) => {
        sortByProbeWorking_net[probename] = {};

        let _filterProbe = rawDataWorking.filter((_C_online0) => {
          return _C_online0.probename.replace(/['"]+/g, "").trim() == probename;
        });

        Object.keys(this._rowSpanWorking.measureName)
          .sort()
          .forEach((measureName, id2) => {
            let _filterMeasureName = _filterProbe.filter((_C_online0) => {
              return _C_online0.name == measureName;
            });
            if (_filterMeasureName.length > 0) {
              sortByProbeWorking_net[probename][measureName] = [];

              Object.keys(this._rowSpanWorking.label)
                .sort()
                .forEach((label) => {
                  let _filterLabel = _filterMeasureName.filter((_C_online0) => {
                    return _C_online0.label == label;
                  });

                  if (_filterLabel.length > 0) {
                    _filterLabel.forEach((row) => {
                      sortByProbeWorking_net[probename][measureName].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanAnomalies.probe)
      .sort()
      .forEach((probename, id) => {
        sortByAnomalies_net[probename] = {};

        let _filterProbe = rawDataAnomalies.filter((_C_online0) => {
          return _C_online0.probename.replace(/['"]+/g, "").trim() == probename;
        });

        Object.keys(this._rowSpanAnomalies.measureName)
          .sort()
          .forEach((measureName, id2) => {
            let _filterMeasureName = _filterProbe.filter((_C_online0) => {
              return _C_online0.name == measureName;
            });
            if (_filterMeasureName.length > 0) {
              sortByAnomalies_net[probename][measureName] = [];

              Object.keys(this._rowSpanAnomalies.label)
                .sort()
                .forEach((label) => {
                  let _filterLabel = _filterMeasureName.filter((_C_online0) => {
                    return _C_online0.label == label;
                  });

                  if (_filterLabel.length > 0) {
                    _filterLabel.forEach((row) => {
                      sortByAnomalies_net[probename][measureName].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanNotEnough.probe)
      .sort()
      .forEach((probename, id) => {
        sortByNotEnough_net[probename] = {};

        let _filterProbe = rawDataNotEnough.filter((_C_online0) => {
          return _C_online0.probename.replace(/['"]+/g, "").trim() == probename;
        });

        Object.keys(this._rowSpanNotEnough.measureName)
          .sort()
          .forEach((measureName, id2) => {
            let _filterMeasureName = _filterProbe.filter((_C_online0) => {
              return _C_online0.name == measureName;
            });
            if (_filterMeasureName.length > 0) {
              sortByNotEnough_net[probename][measureName] = [];

              Object.keys(this._rowSpanNotEnough.label)
                .sort()
                .forEach((label) => {
                  let _filterLabel = _filterMeasureName.filter((_C_online0) => {
                    return _C_online0.label == label;
                  });

                  if (_filterLabel.length > 0) {
                    _filterLabel.forEach((row) => {
                      sortByNotEnough_net[probename][measureName].push(row);
                    });
                  }
                });
            }
          });
      });

    this.setState({
      sortByEssidWorking: null,
      sortByEssidAnomalies: null,
      sortByEssidNotEnough: null,

      sortByApWorking: null,
      sortByApAnomalies: null,
      sortByApNotEnough: null,

      sortByLabelWorking: null,
      sortByLabelAnomalies: null,
      sortByLabelNotEnough: null,

      sortByMeasureNameWorking: null,
      sortByMeasureNameAnomalies: null,
      sortByMeasureNameNotEnough: null,

      sortByProbeWorking: null,
      sortByAnomalies: null,
      sortByNotEnough: null,

      sortMeasureNameWorking: null,
      sortMeasureNameAnomalies: null,
      sortMeasureNameNotEnough: null,

      sortByProbeWorking_net: sortByProbeWorking_net,
      sortByAnomalies_net: sortByAnomalies_net,
      sortByNotEnough_net: sortByNotEnough_net,

      sortLabelWorking: null,
      sortLabelAnomalies: null,
      sortLabelNotEnough: null,
    });
    // console.log(sortByAnomalies);
  }

  formatTableForLabel(data) {
    let rawDataWorking = data.filter((_C_online0) => {
      return _C_online0.color == "success";
    });

    let rawDataAnomalies = data.filter((_C_online0) => {
      return _C_online0.color == "danger" && _C_online0.diag != "N";
    });

    let rawDataNotEnough = data.filter((_C_online0) => {
      return _C_online0.diag == "N";
    });

    let sortByLabelWorking = {};
    let sortByLabelAnomalies = {};
    let sortByLabelNotEnough = {};

    Object.keys(this._rowSpanAnomalies.label)
      .sort()
      .forEach((label, id) => {
        sortByLabelAnomalies[label] = {};

        let _filterLabel = rawDataAnomalies.filter((_C_online0) => {
          return _C_online0.label == label;
        });

        Object.keys(this._rowSpanAnomalies.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterProbe = _filterLabel.filter((_C_online0) => {
              return _C_online0.probename.trim() == probename;
            });
            if (_filterProbe.length > 0) {
              sortByLabelAnomalies[label][probename] = [];

              Object.keys(this._rowSpanAnomalies.measureName)
                .sort()
                .forEach((name) => {
                  let _filterMeasureName = _filterProbe.filter((_C_online0) => {
                    return _C_online0.name == name;
                  });

                  if (_filterMeasureName.length > 0) {
                    _filterMeasureName.forEach((row) => {
                      sortByLabelAnomalies[label][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanNotEnough.label)
      .sort()
      .forEach((label, id) => {
        sortByLabelNotEnough[label] = {};

        let _filterLabel = rawDataNotEnough.filter((_C_online0) => {
          return _C_online0.label == label;
        });

        Object.keys(this._rowSpanNotEnough.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterProbe = _filterLabel.filter((_C_online0) => {
              return _C_online0.probename.trim() == probename;
            });
            if (_filterProbe.length > 0) {
              sortByLabelNotEnough[label][probename] = [];

              Object.keys(this._rowSpanNotEnough.measureName)
                .sort()
                .forEach((name) => {
                  let _filterMeasureName = _filterProbe.filter((_C_online0) => {
                    return _C_online0.name == name;
                  });

                  if (_filterMeasureName.length > 0) {
                    _filterMeasureName.forEach((row) => {
                      sortByLabelNotEnough[label][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanWorking.label)
      .sort()
      .forEach((label, id) => {
        sortByLabelWorking[label] = {};

        let _filterLabel = rawDataWorking.filter((_C_online0) => {
          return _C_online0.label == label;
        });

        Object.keys(this._rowSpanWorking.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterProbe = _filterLabel.filter((_C_online0) => {
              return _C_online0.probename.trim() == probename;
            });
            if (_filterProbe.length > 0) {
              sortByLabelWorking[label][probename] = [];

              Object.keys(this._rowSpanWorking.measureName)
                .sort()
                .forEach((name) => {
                  let _filterMeasureName = _filterProbe.filter((_C_online0) => {
                    return _C_online0.name == name;
                  });

                  if (_filterMeasureName.length > 0) {
                    _filterMeasureName.forEach((row) => {
                      sortByLabelWorking[label][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    this._sortMode = "label";

    this.setState({
      sortByProbeWorking: null,
      sortByAnomalies: null,
      sortByNotEnough: null,

      sortByEssidWorking: null,
      sortByEssidAnomalies: null,
      sortByEssidNotEnough: null,

      sortByLabelWorking: null,
      sortByLabelAnomalies: null,
      sortByLabelNotEnough: null,

      sortByMeasureNameWorking: null,
      sortByMeasureNameAnomalies: null,
      sortByMeasureNameNotEnough: null,

      sortByProbeWorking_net: null,
      sortByAnomalies_net: null,
      sortByNotEnough_net: null,

      sortLabelWorking: sortByLabelWorking,
      sortLabelAnomalies: sortByLabelAnomalies,
      sortLabelNotEnough: sortByLabelNotEnough,

      sortMeasureNameWorking: null,
      sortMeasureNameAnomalies: null,
      sortMeasureNameNotEnough: null,
    });

    // console.log(sortByApWorking);
  }

  formatTableForMeasureName(data) {
    let rawDataWorking = data.filter((_C_online0) => {
      return _C_online0.color == "success";
    });

    let rawDataAnomalies = data.filter((_C_online0) => {
      return _C_online0.color == "danger" && _C_online0.diag != "N";
    });

    let rawDataNotEnough = data.filter((_C_online0) => {
      return _C_online0.diag == "N";
    });

    let sortByMeasureNameWorking = {};
    let sortByMeasureNameAnomalies = {};
    let sortByMeasureNameNotEnough = {};

    Object.keys(this._rowSpanNotEnough.measureName)
      .sort()
      .forEach((name, id) => {
        sortByMeasureNameNotEnough[name] = {};

        let _filterProbe = rawDataNotEnough.filter((_C_online0) => {
          return _C_online0.name == name;
        });

        Object.keys(this._rowSpanNotEnough.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterMeasureName = _filterProbe.filter((_C_online0) => {
              return (
                _C_online0.probename.replace(/['"]+/g, "").trim() == probename
              );
            });
            if (_filterMeasureName.length > 0) {
              sortByMeasureNameNotEnough[name][probename] = [];

              Object.keys(this._rowSpanNotEnough.label)
                .sort()
                .forEach((label) => {
                  let _filterLabel = _filterMeasureName.filter((_C_online0) => {
                    return _C_online0.label == label;
                  });

                  if (_filterLabel.length > 0) {
                    _filterLabel.forEach((row) => {
                      sortByMeasureNameNotEnough[name][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanAnomalies.measureName)
      .sort()
      .forEach((name, id) => {
        sortByMeasureNameAnomalies[name] = {};

        let _filterProbe = rawDataAnomalies.filter((_C_online0) => {
          return _C_online0.name == name;
        });

        Object.keys(this._rowSpanAnomalies.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterMeasureName = _filterProbe.filter((_C_online0) => {
              return (
                _C_online0.probename.replace(/['"]+/g, "").trim() == probename
              );
            });
            if (_filterMeasureName.length > 0) {
              sortByMeasureNameAnomalies[name][probename] = [];

              Object.keys(this._rowSpanAnomalies.label)
                .sort()
                .forEach((label) => {
                  let _filterLabel = _filterMeasureName.filter((_C_online0) => {
                    return _C_online0.label == label;
                  });

                  if (_filterLabel.length > 0) {
                    _filterLabel.forEach((row) => {
                      sortByMeasureNameAnomalies[name][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    Object.keys(this._rowSpanWorking.measureName)
      .sort()
      .forEach((name, id) => {
        sortByMeasureNameWorking[name] = {};

        let _filterProbe = rawDataWorking.filter((_C_online0) => {
          return _C_online0.name == name;
        });

        Object.keys(this._rowSpanWorking.probe)
          .sort()
          .forEach((probename, id2) => {
            let _filterMeasureName = _filterProbe.filter((_C_online0) => {
              return (
                _C_online0.probename.replace(/['"]+/g, "").trim() == probename
              );
            });
            if (_filterMeasureName.length > 0) {
              sortByMeasureNameWorking[name][probename] = [];

              Object.keys(this._rowSpanWorking.label)
                .sort()
                .forEach((label) => {
                  let _filterLabel = _filterMeasureName.filter((_C_online0) => {
                    return _C_online0.label == label;
                  });

                  if (_filterLabel.length > 0) {
                    _filterLabel.forEach((row) => {
                      sortByMeasureNameWorking[name][probename].push(row);
                    });
                  }
                });
            }
          });
      });

    this._sortMode = "measureName";

    this.setState({
      sortByProbeWorking: null,
      sortByAnomalies: null,
      sortByNotEnough: null,

      sortByApWorking: null,
      sortByApAnomalies: null,
      sortByApNotEnough: null,

      sortByLabelWorking: null,
      sortByLabelAnomalies: null,
      sortByLabelNotEnough: null,

      sortByMeasureNameWorking: null,
      sortByMeasureNameAnomalies: null,
      sortByMeasureNameNotEnough: null,

      sortByProbeWorking_net: null,
      sortByAnomalies_net: null,
      sortByNotEnough_net: null,

      sortMeasureNameWorking: sortByMeasureNameWorking,
      sortMeasureNameAnomalies: sortByMeasureNameAnomalies,
      sortMeasureNameNotEnough: sortByMeasureNameNotEnough,

      sortLabelWorking: null,
      sortLabelAnomalies: null,
      sortLabelNotEnough: null,
    });

    // console.log(sortByEssidWorking);
    // console.log(this._rowSpanWorking);
  }

  makeInfoText(diff) {
    if (diff < 3600) {
      const min = diff / 60;
      return this.generateText({
        value: min,
        time: "minutes",
        color: "muted",
      });
    }
    if (diff >= 3600 && diff < 86400) {
      const hours = diff / 3600;
      return this.generateText({
        value: hours,
        time: "hours",
        color: "danger",
      });
    }
    if (diff >= 86400) {
      const days = diff / 86400;
      return this.generateText({
        value: days,
        time: "days",
        color: "danger",
      });
    }
  }

  generateText({ value, time, color }) {
    return (
      <div className={`text-${color} py-3`}>
        <strong>{`The current diagnostics may differ from those mentioned in the email you received over ${parseInt(
          value,
        )} ${time} ago.`}</strong>
      </div>
    );
  }

  onComponentWillUnmount() {
    this.mounted = false;
    clearInterval(this._autorefresh);
  }

  onRender() {
    return (
      <Section designType="narrow">
        <_LoadingWrapper
          loadingPlug={this.state.loading}
          hideOnLoading={true}
          minHeight
        >
          {this.state.infoText && this.state.infoText}
          <div
            className={
              this.getAppContext().media.isMobile
                ? "mb-2"
                : "d-flex flex-grow-1 mb-1"
            }
          >
            {this.state.data &&
            this.state.data.online.length == 0 &&
            this.state.data.offline.length == 0 ? null : (
              <div className="d-flex justify-content-between flex-grow-1 pt-3">
                <div></div>
                <div>
                  <ReactOForm
                    onControllerReady={(form_controller) => {
                      this._reload_form = form_controller;
                    }}
                    onFormDataChange={(new_data) => {
                      if (new_data.autorefresh == "on") {
                        setTimeout(() => {
                          this.loadDiag(true);
                        }, 120000);
                      } else if (new_data.autorefresh == "off") {
                        clearInterval(this._autorefresh);
                      }
                    }}
                  >
                    <strong
                      className="sub-title mr-2"
                      style={{ display: "inline-block" }}
                    >
                      Autorefresh every 2 minutes
                    </strong>
                    <div style={{ display: "inline-block" }}>
                      <ReactOFormInput type="switch" data_key="autorefresh" />
                    </div>
                  </ReactOForm>
                </div>
              </div>
            )}
          </div>
          {this.state.data ? (
            <div>
              {this.state.data.online.length == 0 &&
              this.state.data.offline.length == 0 ? (
                <Panel bodyClassName="p-4" rounded>
                  <span className="py-3"> No measures or probes</span>
                </Panel>
              ) : (
                <div>
                  {/* ANOMALIES TABLE */}

                  {this._anomaliesCount != 0 ? (
                    <div className="mb-1">
                      <Panel bodyClassName="p-0" rounded>
                        <div
                          className="diag-bg"
                          onClick={() => {
                            this._advanced_collapse2.toggle();
                          }}
                        >
                          <div className="py-3">
                            <Col xs={12}>
                              <Row
                                noGutters
                                style={
                                  this.getAppContext().media.isMobile
                                    ? { display: "block" }
                                    : null
                                }
                              >
                                <div
                                  className={
                                    this.getAppContext().media.isMobile
                                      ? "mb-2"
                                      : "flex-grow-1"
                                  }
                                >
                                  <h5 className="pt-2">
                                    {this._anomaliesCount == 1
                                      ? this._anomaliesCount +
                                        "/" +
                                        this.state.data.online.length +
                                        " measure with anomalies"
                                      : this._anomaliesCount +
                                        "/" +
                                        this.state.data.online.length +
                                        " measures with anomalies "}
                                  </h5>
                                </div>
                                {this.getAppContext().media.isMobile ? (
                                  <div className="d-flex flex-grow-1">
                                    <div className="pt-1 flex-grow-1">
                                      <strong>
                                        {Object.keys(this._countProbAnomalies)
                                          .length + " PROBE "}
                                        {this.getAppContext().platformName() ==
                                        "WiFiProbe"
                                          ? Object.keys(
                                              this._countEssidAnomalies,
                                            ).length + " ESSID "
                                          : Object.keys(
                                              this._countMeasureNameAnomalies,
                                            ).length + " MEASURE "}
                                        {this.getAppContext().platformName() ==
                                        "WiFiProbe"
                                          ? this._countAPsAnomalies["-"]
                                            ? this._countAPsAnomalies["-"] +
                                              Object.keys(
                                                this._countAPsAnomalies,
                                              ).length -
                                              1 +
                                              " AP "
                                            : Object.keys(
                                                this._countAPsAnomalies,
                                              ).length + " AP"
                                          : Object.keys(
                                              this._countLabelAnomalies,
                                            ).length + " LABEL "}
                                      </strong>
                                    </div>
                                    <div className="pt-2 justify-content-end">
                                      <span
                                        className={
                                          this.state
                                            ._advanced_collapse_opened2 == false
                                            ? "icon-caret-down-outline"
                                            : "icon-caret-up-outline"
                                        }
                                      ></span>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="pt-2 justify-content-end">
                                    <strong>
                                      {
                                        "Involved:\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                      }
                                      {Object.keys(this._countProbAnomalies)
                                        .length +
                                        " PROBE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                      {this.getAppContext().platformName() ==
                                      "WiFiProbe"
                                        ? Object.keys(this._countEssidAnomalies)
                                            .length +
                                          " ESSID\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                        : Object.keys(
                                            this._countMeasureNameAnomalies,
                                          ).length +
                                          " MEASURE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                      {this.getAppContext().platformName() ==
                                      "WiFiProbe"
                                        ? this._countAPsAnomalies["-"]
                                          ? this._countAPsAnomalies["-"] +
                                            Object.keys(this._countAPsAnomalies)
                                              .length -
                                            1 +
                                            " AP "
                                          : Object.keys(this._countAPsAnomalies)
                                              .length + " AP"
                                        : Object.keys(this._countLabelAnomalies)
                                            .length + " LABEL "}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}Details
                                      <span
                                        className={
                                          this.state
                                            ._advanced_collapse_opened2 == false
                                            ? "icon-caret-down-outline"
                                            : "icon-caret-up-outline"
                                        }
                                      ></span>
                                    </strong>
                                  </div>
                                )}
                              </Row>
                            </Col>
                          </div>
                        </div>

                        <ReactOCollapse
                          className="border-top border-2 border-danger"
                          onControllerReady={(_collapse_controller) => {
                            this._advanced_collapse2 = _collapse_controller;
                            this.setState({
                              _advanced_collapse_opened2: false,
                            });
                          }}
                          onOpened={() => {
                            this.setState({ _advanced_collapse_opened2: true });
                          }}
                          onClosed={() => {
                            this.setState({
                              _advanced_collapse_opened2: false,
                            });
                          }}
                          initOpen={this.checkOpen("1", this._anomaliesCount)}
                        >
                          {this.state.sortByAnomalies != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "ESSID",
                                  data_key: "essid",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "AP",
                                  data_key: "aps",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanAnomalies}
                              data={this.state.sortByAnomalies}
                              renderKey="probe"
                            />
                          ) : null}

                          {this.state.sortByAnomalies_net != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "MEASURE",
                                  data_key: "measure",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "LABEL",
                                  data_key: "label",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanAnomalies}
                              data={this.state.sortByAnomalies_net}
                              renderKey="probe_net"
                            />
                          ) : null}

                          {this.state.sortByEssidAnomalies != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "ESSID",
                                  data_key: "essid",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "AP",
                                  data_key: "aps",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanAnomalies}
                              data={this.state.sortByEssidAnomalies}
                              renderKey="essid"
                            />
                          ) : null}

                          {this.state.sortMeasureNameAnomalies != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "MEASURE",
                                  data_key: "measure",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "LABEL",
                                  data_key: "label",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanAnomalies}
                              data={this.state.sortMeasureNameAnomalies}
                              renderKey="measureName"
                            />
                          ) : null}

                          {this.state.sortByApAnomalies != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "AP",
                                  data_key: "aps",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "ESSID",
                                  data_key: "essid",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanAnomalies}
                              data={this.state.sortByApAnomalies}
                              renderKey="ap"
                            />
                          ) : null}

                          {this.state.sortLabelAnomalies != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "LABEL",
                                  data_key: "label",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "MEASURE",
                                  data_key: "measure",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanAnomalies}
                              data={this.state.sortLabelAnomalies}
                              renderKey="label"
                            />
                          ) : null}
                        </ReactOCollapse>
                      </Panel>
                    </div>
                  ) : null}

                  {/* NOT ENOUGH TABLE */}
                  {this._notEnoughCount != 0 ? (
                    <div className="mb-1">
                      <Panel bodyClassName="p-0" rounded>
                        <div
                          className="diag-bg"
                          onClick={() => {
                            this._advanced_collapseN.toggle();
                          }}
                        >
                          <div className="py-3">
                            <Col xs={12}>
                              <Row
                                noGutters
                                style={
                                  this.getAppContext().media.isMobile
                                    ? { display: "block" }
                                    : null
                                }
                              >
                                <div
                                  className={
                                    this.getAppContext().media.isMobile
                                      ? "mb-2"
                                      : "flex-grow-1"
                                  }
                                >
                                  <h5 className="pt-2">
                                    {this._notEnoughCount == 1
                                      ? this._notEnoughCount +
                                        " measure with not enough data"
                                      : this._notEnoughCount +
                                        " measures with not enough data "}
                                  </h5>
                                </div>

                                {this.getAppContext().media.isMobile ? (
                                  <div className="d-flex flex-grow-1">
                                    <div className="pt-1 flex-grow-1">
                                      <strong>
                                        {Object.keys(this._countProbNotEnough)
                                          .length + " PROBE "}
                                        {this.getAppContext().platformName() ==
                                        "WiFiProbe"
                                          ? Object.keys(
                                              this._countEssidNotEnough,
                                            ).length + " ESSID "
                                          : Object.keys(
                                              this._countMeasureNameNotEnough,
                                            ).length + " MEASURE "}
                                        {this.getAppContext().platformName() ==
                                        "WiFiProbe"
                                          ? this._countApsNotEnough["-"]
                                            ? this._countApsNotEnough["-"] +
                                              Object.keys(
                                                this._countApsNotEnough,
                                              ).length -
                                              1 +
                                              " AP "
                                            : Object.keys(
                                                this._countApsNotEnough,
                                              ).length + " AP"
                                          : Object.keys(
                                              this._countLabelNotEnough,
                                            ).length + " LABEL "}
                                      </strong>
                                    </div>
                                    <div className="pt-2 justify-content-end">
                                      <span
                                        className={
                                          this.state
                                            ._advanced_collapse_opened2 == false
                                            ? "icon-caret-down-outline"
                                            : "icon-caret-up-outline"
                                        }
                                      ></span>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="pt-2">
                                    <strong>
                                      {
                                        "Involved:\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                      }
                                      {Object.keys(this._countProbNotEnough)
                                        .length +
                                        " PROBE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                      {this.getAppContext().platformName() ==
                                      "WiFiProbe"
                                        ? Object.keys(this._countEssidNotEnough)
                                            .length +
                                          " ESSID\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                        : Object.keys(
                                            this._countMeasureNameNotEnough,
                                          ).length +
                                          " MEASURE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                      {this.getAppContext().platformName() ==
                                      "WiFiProbe"
                                        ? this._countApsNotEnough["-"]
                                          ? this._countApsNotEnough["-"] +
                                            Object.keys(this._countApsNotEnough)
                                              .length -
                                            1 +
                                            " AP "
                                          : Object.keys(this._countApsNotEnough)
                                              .length + " AP"
                                        : Object.keys(this._countLabelNotEnough)
                                            .length + " LABEL "}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}
                                      {"\u00A0"}Details
                                      <span
                                        className={
                                          this.state
                                            ._advanced_collapse_opened2 == false
                                            ? "icon-caret-down-outline"
                                            : "icon-caret-up-outline"
                                        }
                                      ></span>
                                    </strong>
                                  </div>
                                )}
                              </Row>
                            </Col>
                          </div>
                        </div>

                        <ReactOCollapse
                          className="border-top border-2 border-danger"
                          onControllerReady={(_collapse_controller) => {
                            this._advanced_collapseN = _collapse_controller;
                            this.setState({
                              _advanced_collapse_openedN: false,
                            });
                          }}
                          onOpened={() => {
                            this.setState({ _advanced_collapse_openedN: true });
                          }}
                          onClosed={() => {
                            this.setState({
                              _advanced_collapse_openedN: false,
                            });
                          }}
                          // initOpen={this._notEnoughCount < 4}
                          initOpen={this.checkOpen("2", this._notEnoughCount)}
                        >
                          {this.state.sortByNotEnough != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "ESSID",
                                  data_key: "essid",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "AP",
                                  data_key: "aps",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanNotEnough}
                              data={this.state.sortByNotEnough}
                              renderKey="probe"
                            />
                          ) : null}

                          {this.state.sortByNotEnough_net != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "MEASURE",
                                  data_key: "measure",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "LABEL",
                                  data_key: "label",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanNotEnough}
                              data={this.state.sortByNotEnough_net}
                              renderKey="probe_net"
                            />
                          ) : null}

                          {this.state.sortByEssidNotEnough != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "ESSID",
                                  data_key: "essid",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "AP",
                                  data_key: "aps",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanNotEnough}
                              data={this.state.sortByEssidNotEnough}
                              renderKey="essid"
                            />
                          ) : null}

                          {this.state.sortMeasureNameNotEnough != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "MEASURE",
                                  data_key: "measure",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "LABEL",
                                  data_key: "label",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanNotEnough}
                              data={this.state.sortMeasureNameNotEnough}
                              renderKey="measureName"
                            />
                          ) : null}

                          {this.state.sortByApNotEnough != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "AP",
                                  data_key: "aps",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "ESSID",
                                  data_key: "essid",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanNotEnough}
                              data={this.state.sortByApNotEnough}
                              renderKey="ap"
                            />
                          ) : null}

                          {this.state.sortLabelNotEnough != null ? (
                            <RowSpanTableDiag
                              cols={[
                                {
                                  title: "LABEL",
                                  data_key: "label",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "PROBE",
                                  data_key: "probe",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "MEASURE",
                                  data_key: "measure",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "STATUS",
                                  data_key: "status",
                                  align: "center",
                                  width: "20",
                                },
                                {
                                  title: "SINCE",
                                  data_key: "since",
                                  align: "center",
                                  width: "20",
                                },
                              ]}
                              rowSpan={this._rowSpanNotEnough}
                              data={this.state.sortLabelNotEnough}
                              renderKey="label"
                            />
                          ) : null}
                        </ReactOCollapse>
                      </Panel>
                    </div>
                  ) : null}

                  {/* OFFLINE TABLE */}

                  {this.state.data.offline.length > 0 ? (
                    <div className="mt-2">
                      <Panel bodyClassName="p-0" rounded>
                        <div
                          className="diag-bg"
                          onClick={() => {
                            this._advanced_collapse1.toggle();
                          }}
                        >
                          <div className="py-3">
                            <Col xs={12}>
                              <Row
                                noGutters
                                style={
                                  this.getAppContext().media.isMobile
                                    ? { display: "block" }
                                    : null
                                }
                              >
                                <div className="d-flex flex-grow-1">
                                  <div className="flex-grow-1">
                                    <h5 className="pt-2">
                                      {this.state.data.zzz_offline == 1
                                        ? this.state.data.zzz_offline +
                                          " probe offline"
                                        : this.state.data.zzz_offline +
                                          " probes offline"}
                                    </h5>
                                  </div>

                                  <div className="pt-2 justify-content-end">
                                    <strong>
                                      {this.getAppContext().media.isMobile
                                        ? null
                                        : "Details "}
                                      <span
                                        className={
                                          this.state
                                            ._advanced_collapse_opened1 == false
                                            ? "icon-caret-down-outline"
                                            : "icon-caret-up-outline"
                                        }
                                      ></span>
                                    </strong>
                                  </div>
                                </div>
                              </Row>
                            </Col>
                          </div>
                        </div>

                        <ReactOCollapse
                          className="border-top border-2 border-danger"
                          onControllerReady={(_collapse_controller) => {
                            this._advanced_collapse1 = _collapse_controller;
                            this.setState({
                              _advanced_collapse_opened1: false,
                            });
                          }}
                          onOpened={() => {
                            this.setState({ _advanced_collapse_opened1: true });
                          }}
                          onClosed={() => {
                            this.setState({
                              _advanced_collapse_opened1: false,
                            });
                          }}
                          // initOpen={false}
                          initOpen={this.checkOpen("3")}
                        >
                          <ReactOTable
                            thClassName="px-3 py-1"
                            tdClassName="align-middle px-3 py-2"
                            hoverable
                            onRowClick={
                              this.props.onItemClick
                                ? this.props.onItemClick
                                : (row_data) => {
                                    // console.log(row_data);
                                  }
                            }
                            compressed={
                              this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                            }
                            compressedRowRendering={(row_items, link) => {
                              return link ? (
                                <div>
                                  <Link
                                    className="link-table-test"
                                    to={link}
                                    target="_blank"
                                  >
                                    <div className="mt-2">
                                      <div className="text-muted">
                                        <small className="">
                                          <strong>
                                            {row_items.probe.title}
                                          </strong>
                                        </small>
                                      </div>
                                      {row_items.probe.content}
                                    </div>
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>
                                          {row_items.status.title}
                                        </strong>
                                      </small>
                                    </div>
                                    {row_items.status.content}
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.since.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.since.content}
                                  </Link>
                                </div>
                              ) : (
                                <div>
                                  <div className="mt-2">
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.probe.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.probe.content}
                                  </div>
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.status.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.status.content}
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.since.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.since.content}
                                </div>
                              );
                            }}
                            thDividers
                            defaultSort={[
                              {
                                data_key: "since",
                                order: "asc",
                              },
                              {
                                data_key: "probe",
                                order: "asc",
                              },
                              {
                                data_key: "status",
                                order: "asc",
                              },
                            ]}
                            cols={[
                              {
                                title: "PROBE",
                                align: "center",
                                data_key: "probe",
                                width: "30",
                                sortable: true,
                              },
                              {
                                title: "STATUS",
                                align: "center",
                                data_key: "status",
                                width: "30",
                                sortable: true,
                              },
                              {
                                title: "SINCE",
                                align: "center",
                                data_key: "since",
                                width: "30",
                                sortable: true,
                              },
                            ]}
                            rows={(() => {
                              let _TMP1 = [];
                              this.state.data.offline.forEach(
                                (_C_row, C_id) => {
                                  _TMP1.push({
                                    _link: "/" + _C_row.probeid + "/active/",
                                    _title: `View active measures for ${_C_row.name}`,
                                    probe: {
                                      value: _C_row.name,
                                      info: _C_row.probeid,
                                      render: (
                                        <div>
                                          <div>
                                            <strong>
                                              {" "}
                                              {_C_row.name}{" "}
                                            </strong>{" "}
                                          </div>
                                          <span className="sub-title">
                                            {" "}
                                            {_C_row.mac}{" "}
                                          </span>
                                        </div>
                                      ),
                                    },
                                    status: {
                                      value: "offline",
                                      render: (
                                        <div>
                                          <span className="text-danger">
                                            Offline
                                          </span>
                                          {_C_row.step ? (
                                            <div className="sub-title text-danger">
                                              {_C_row.step}
                                            </div>
                                          ) : null}
                                        </div>
                                      ),
                                    },
                                    since: {
                                      value: _C_row.since,
                                      render: (
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(_C_row.since, "X")
                                            .format("YYYY") < 2014 ? (
                                            "-"
                                          ) : (
                                            <div>
                                              <div>
                                                {this.getAppContext()
                                                  .momentjs(_C_row.since, "X")
                                                  .format("DD-MM-YYYY")}
                                              </div>
                                              <div className="sub-title">
                                                {this.getAppContext()
                                                  .momentjs(_C_row.since, "X")
                                                  .format("HH:mm")}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ), // check per date < 2014. Cambiare la regex /([0-9]){4}/g in caso di diversa formattazione dell'anno
                                    },
                                  });
                                },
                              );
                              return _TMP1;
                            })()}
                          ></ReactOTable>
                        </ReactOCollapse>
                      </Panel>
                    </div>
                  ) : (
                    <div className="mt-2">
                      <Panel bodyClassName="p-3" rounded>
                        <h5>All probes are online</h5>
                      </Panel>
                    </div>
                  )}

                  {/* MAINTENANCE TABLE */}

                  {this.state.data && this.state.data.zzz_maintenance != 0 ? (
                    <div>
                      <Panel className="mt-4" bodyClassName="p-0" rounded>
                        <div
                          className="maintenance-bg"
                          onClick={() => {
                            this._advanced_collapse_m.toggle();
                          }}
                        >
                          <div className="py-3">
                            <Col xs={12}>
                              <Row
                                noGutters
                                style={
                                  this.getAppContext().media.isMobile
                                    ? { display: "block" }
                                    : null
                                }
                              >
                                <div className="d-flex flex-grow-1">
                                  <div className="flex-grow-1">
                                    <h5 className="pt-2">
                                      {this.state.data.zzz_maintenance == 1
                                        ? this.state.data.zzz_maintenance +
                                          " probe in maintenance"
                                        : this.state.data.zzz_maintenance +
                                          " probes in maintenance"}
                                    </h5>
                                  </div>

                                  <div className="pt-2 justify-content-end">
                                    {this.countOfflineProbes(
                                      this.state.data.maintenance,
                                    ) > 0 && (
                                      <strong>
                                        {`Offline: ${this.countOfflineProbes(
                                          this.state.data.maintenance,
                                        )}\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0`}
                                      </strong>
                                    )}
                                    <strong>
                                      {this.getAppContext().media.isMobile
                                        ? null
                                        : "Details "}
                                      <span
                                        className={
                                          this.state
                                            ._advanced_collapse_opened_m ==
                                          false
                                            ? "icon-caret-down-outline"
                                            : "icon-caret-up-outline"
                                        }
                                      ></span>
                                    </strong>
                                  </div>
                                </div>
                              </Row>
                            </Col>
                          </div>
                        </div>

                        <ReactOCollapse
                          className="border-top border-2 border-warning"
                          onControllerReady={(_collapse_controller) => {
                            this._advanced_collapse_m = _collapse_controller;
                            this.setState({
                              _advanced_collapse_opened_m: false,
                            });
                          }}
                          onOpened={() => {
                            this.setState({
                              _advanced_collapse_opened_m: true,
                            });
                          }}
                          onClosed={() => {
                            this.setState({
                              _advanced_collapse_opened_m: false,
                            });
                          }}
                          initOpen={this.checkOpen("4")}
                        >
                          <ReactOTable
                            thClassName="px-3 py-1"
                            tdClassName="align-middle px-3 py-2"
                            hoverable
                            compressed={
                              this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                            }
                            compressedRowRendering={(row_items, link) => {
                              return link ? (
                                <div>
                                  <Link
                                    className="link-table-test"
                                    to={link}
                                    target="_blank"
                                  >
                                    <div className="mt-2">
                                      <div className="text-muted">
                                        <small className="">
                                          <strong>
                                            {row_items.probe.title}
                                          </strong>
                                        </small>
                                      </div>
                                      {row_items.probe.content}
                                    </div>
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>
                                          {row_items.status.title}
                                        </strong>
                                      </small>
                                    </div>
                                    {row_items.status.content}
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.since.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.since.content}
                                  </Link>
                                </div>
                              ) : (
                                <div>
                                  <div className="mt-2">
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.probe.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.probe.content}
                                  </div>
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.status.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.status.content}
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.since.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.since.content}
                                </div>
                              );
                            }}
                            thDividers
                            defaultSort={[
                              {
                                data_key: "since",
                                order: "asc",
                              },
                              {
                                data_key: "probe",
                                order: "asc",
                              },
                              {
                                data_key: "status",
                                order: "asc",
                              },
                            ]}
                            cols={[
                              {
                                title: "PROBE",
                                align: "center",
                                data_key: "probe",
                                width: "30",
                                sortable: true,
                              },
                              {
                                title: "STATUS",
                                align: "center",
                                data_key: "status",
                                width: "30",
                                sortable: true,
                              },
                              {
                                title: "SINCE",
                                align: "center",
                                data_key: "since",
                                width: "30",
                                sortable: true,
                              },
                            ]}
                            // onRowClick={(row_data) => {
                            //   this.getAppContext().redirectTo(
                            //     "/" + row_data.probe.info.replace(/:/g, "") + "/active/"
                            //   );
                            // }}
                            onRowClick={
                              this.props.onItemClick
                                ? this.props.onItemClick
                                : (row_data) => {
                                    // console.log(row_data);
                                  }
                            }
                            rows={(() => {
                              let _TMP1 = [];
                              this.state.data.maintenance.forEach(
                                (_C_row, C_id) => {
                                  _TMP1.push({
                                    _link: "/" + _C_row.probeid + "/active/",
                                    _title: `View active measures for ${_C_row.name}`,
                                    probe: {
                                      value: _C_row.name,
                                      info: _C_row.probeid,
                                      render: (
                                        <div>
                                          <div>
                                            <strong> {_C_row.name} </strong>
                                          </div>
                                          <span className="sub-title">
                                            {" "}
                                            {_C_row.mac}{" "}
                                          </span>
                                        </div>
                                      ),
                                    },
                                    status: {
                                      value: _C_row.sync_status,
                                      render: (
                                        <span>
                                          {_C_row.sync_status == 0 ? (
                                            <div>
                                              <span className="text-danger">
                                                Offline
                                              </span>
                                              {_C_row.step ? (
                                                <div className="sub-title text-danger">
                                                  {_C_row.step}
                                                </div>
                                              ) : null}
                                            </div>
                                          ) : (
                                            <div>
                                              <span className="text-success">
                                                Online
                                              </span>
                                              {_C_row.step ? (
                                                <div className="sub-title text-success">
                                                  {_C_row.step}
                                                </div>
                                              ) : null}
                                            </div>
                                          )}
                                        </span>
                                      ),
                                    },
                                    since: {
                                      value: _C_row.since,
                                      render: (
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(_C_row.since, "X")
                                            .format("YYYY") < 2014 ? (
                                            "-"
                                          ) : (
                                            <div>
                                              <div>
                                                {this.getAppContext()
                                                  .momentjs(_C_row.since, "X")
                                                  .format("DD-MM-YYYY")}
                                              </div>
                                              <div className="sub-title">
                                                {this.getAppContext()
                                                  .momentjs(_C_row.since, "X")
                                                  .format("HH:mm")}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ), // check per date < 2014. Cambiare la regex /([0-9]){4}/g in caso di diversa formattazione dell'anno
                                    },
                                  });
                                },
                              );
                              return _TMP1;
                            })()}
                          ></ReactOTable>
                        </ReactOCollapse>
                      </Panel>
                    </div>
                  ) : null}

                  {/* WORKING TABLE */}

                  <Panel className="mt-2" bodyClassName="p-0" rounded>
                    <div
                      className="working-bg"
                      onClick={
                        this._workingCount != 0
                          ? () => {
                              this._advanced_collapse3.toggle();
                            }
                          : null
                      }
                    >
                      <div className="py-3">
                        <Col xs={12}>
                          <Row
                            noGutters
                            style={
                              this.getAppContext().media.isMobile
                                ? { display: "block" }
                                : null
                            }
                          >
                            <div
                              className={
                                this.getAppContext().media.isMobile
                                  ? "mb-2"
                                  : "flex-grow-1"
                              }
                            >
                              <h5 className="pt-2">
                                {this._workingCount == 1
                                  ? this._workingCount +
                                    "/" +
                                    this.state.data.online.length +
                                    " working measure "
                                  : this._workingCount +
                                    "/" +
                                    this.state.data.online.length +
                                    " working measures "}
                              </h5>
                            </div>
                            {this._workingCount != 0 ? (
                              this.getAppContext().media.isMobile ? (
                                <div className="d-flex flex-grow-1">
                                  <div className="pt-1 flex-grow-1">
                                    <strong>
                                      {Object.keys(this._countProbWorking)
                                        .length + " PROBE "}
                                      {this.getAppContext().platformName() ==
                                      "WiFiProbe"
                                        ? Object.keys(this._countEssidWorking)
                                            .length + " ESSID "
                                        : Object.keys(
                                            this._countMeasureNameWorking,
                                          ).length + " MEASURE "}

                                      {this._countAPsWorking["-"]
                                        ? Object.keys(this._countAPsWorking)
                                            .length + " AP "
                                        : Object.keys(this._countAPsWorking)
                                            .length + " AP "}
                                    </strong>
                                  </div>
                                  <div className="pt-2 justify-content-end">
                                    <span
                                      className={
                                        this.state._advanced_collapse_opened2 ==
                                        false
                                          ? "icon-caret-down-outline"
                                          : "icon-caret-up-outline"
                                      }
                                    ></span>
                                  </div>
                                </div>
                              ) : (
                                <div className="pt-2">
                                  <strong>
                                    {
                                      "Involved:\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                    }
                                    {Object.keys(this._countProbWorking)
                                      .length +
                                      " PROBE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                    {this.getAppContext().platformName() ==
                                    "WiFiProbe"
                                      ? Object.keys(this._countEssidWorking)
                                          .length +
                                        " ESSID\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                      : Object.keys(
                                          this._countMeasureNameWorking,
                                        ).length +
                                        " MEASURE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                    {this.getAppContext().platformName() ==
                                    "WiFiProbe"
                                      ? this._countAPsWorking["-"]
                                        ? Object.keys(this._countAPsWorking)
                                            .length + " AP "
                                        : Object.keys(this._countAPsWorking)
                                            .length + " AP"
                                      : null}
                                    {"\u00A0"}
                                    {"\u00A0"}
                                    {"\u00A0"}
                                    {"\u00A0"}
                                    {"\u00A0"}
                                    {"\u00A0"}
                                    {"\u00A0"}Details
                                    <span
                                      className={
                                        this.state._advanced_collapse_opened3 ==
                                        false
                                          ? "icon-caret-down-outline"
                                          : "icon-caret-up-outline"
                                      }
                                    ></span>
                                  </strong>
                                </div>
                              )
                            ) : null}
                          </Row>
                        </Col>
                      </div>
                    </div>

                    <ReactOCollapse
                      className="border-top border-2 border-success"
                      onControllerReady={(_collapse_controller) => {
                        this._advanced_collapse3 = _collapse_controller;
                        this.setState({ _advanced_collapse_opened3: false });
                      }}
                      onOpened={() => {
                        this.setState({ _advanced_collapse_opened3: true });
                      }}
                      onClosed={() => {
                        this.setState({ _advanced_collapse_opened3: false });
                      }}
                      initOpen={this.checkOpen("5")}
                    >
                      {this.state.sortByProbeWorking != null ? (
                        <RowSpanTableDiag
                          cols={[
                            {
                              title: "PROBE",
                              data_key: "probe",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "ESSID",
                              data_key: "essid",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "AP",
                              data_key: "aps",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "STATUS",
                              data_key: "status",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "SINCE",
                              data_key: "since",
                              align: "center",
                              width: "20",
                            },
                          ]}
                          rowSpan={this._rowSpanWorking}
                          data={this.state.sortByProbeWorking}
                          renderKey="probe"
                        />
                      ) : null}

                      {this.state.sortByProbeWorking_net != null ? (
                        <RowSpanTableDiag
                          cols={[
                            {
                              title: "PROBE",
                              data_key: "probe",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "TEST",
                              data_key: "test",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "MEASURE",
                              data_key: "measure",
                              align: "center",
                              width: "20",
                            },

                            {
                              title: "STATUS",
                              data_key: "status",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "SINCE",
                              data_key: "since",
                              align: "center",
                              width: "20",
                            },
                          ]}
                          rowSpan={this._rowSpanWorking}
                          data={this.state.sortByProbeWorking_net}
                          renderKey="probe_net"
                        />
                      ) : null}

                      {this.state.sortByEssidWorking != null ? (
                        <RowSpanTableDiag
                          cols={[
                            {
                              title: "ESSID",
                              data_key: "essid",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "PROBE",
                              data_key: "probe",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "AP",
                              data_key: "aps",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "STATUS",
                              data_key: "status",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "SINCE",
                              data_key: "since",
                              align: "center",
                              width: "20",
                            },
                          ]}
                          rowSpan={this._rowSpanWorking}
                          data={this.state.sortByEssidWorking}
                          renderKey="essid"
                        />
                      ) : null}

                      {this.state.sortMeasureNameWorking != null ? (
                        <RowSpanTableDiag
                          cols={[
                            {
                              title: "MEASURE",
                              data_key: "measure",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "PROBE",
                              data_key: "probe",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "LABEL",
                              data_key: "label",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "STATUS",
                              data_key: "status",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "SINCE",
                              data_key: "since",
                              align: "center",
                              width: "20",
                            },
                          ]}
                          rowSpan={this._rowSpanWorking}
                          data={this.state.sortMeasureNameWorking}
                          renderKey="measureName"
                        />
                      ) : null}

                      {this.state.sortByApWorking != null ? (
                        <RowSpanTableDiag
                          cols={[
                            {
                              title: "AP",
                              data_key: "aps",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "PROBE",
                              data_key: "probe",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "ESSID",
                              data_key: "essid",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "STATUS",
                              data_key: "status",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "SINCE",
                              data_key: "since",
                              align: "center",
                              width: "20",
                            },
                          ]}
                          rowSpan={this._rowSpanWorking}
                          data={this.state.sortByApWorking}
                          renderKey="ap"
                        />
                      ) : null}

                      {this.state.sortLabelWorking != null ? (
                        <RowSpanTableDiag
                          cols={[
                            {
                              title: "LABEL",
                              data_key: "label",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "PROBE",
                              data_key: "probe",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "MEASURE",
                              data_key: "measure",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "STATUS",
                              data_key: "status",
                              align: "center",
                              width: "20",
                            },
                            {
                              title: "SINCE",
                              data_key: "since",
                              align: "center",
                              width: "20",
                            },
                          ]}
                          rowSpan={this._rowSpanWorking}
                          data={this.state.sortLabelWorking}
                          renderKey="label"
                        />
                      ) : null}
                    </ReactOCollapse>
                  </Panel>
                </div>
              )}
            </div>
          ) : null}

          {this.state.data &&
            this.state.data.online.filter(
              (m) => m.diag == "N" && m.explicit_mac == "no",
            ).length > 0 && (
              <div>
                <Panel className="mt-2" bodyClassName="p-0" rounded>
                  <div
                    style={{ cursor: "pointer" }}
                    className=""
                    onClick={() => {
                      this._advanced_collapse8.toggle();
                    }}
                  >
                    <div className="py-3">
                      <Col xs={12}>
                        <Row
                          noGutters
                          style={
                            this.getAppContext().media.isMobile
                              ? { display: "block" }
                              : null
                          }
                        >
                          <div className="d-flex flex-grow-1">
                            <div className="flex-grow-1">
                              <h5 className="pt-2">
                                {this._notEnoughCount_ex == 1
                                  ? this._notEnoughCount_ex +
                                    "/" +
                                    this.state.data.online.length +
                                    " measure with not enough data "
                                  : this._notEnoughCount_ex +
                                    "/" +
                                    this.state.data.online.length +
                                    " measures with not enough data "}
                              </h5>
                            </div>

                            <div className="pt-2 justify-content-end">
                              <div className="pt-2">
                                <strong>
                                  {
                                    "Involved:\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                  }
                                  {Object.keys(this._countProbNotEnough_ex)
                                    .length +
                                    " PROBE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                  {this.getAppContext().platformName() ==
                                  "WiFiProbe"
                                    ? Object.keys(this._countProbNotEnough_ex)
                                        .length +
                                      " ESSID\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"
                                    : Object.keys(this._countProbNotEnough_ex)
                                        .length +
                                      " MEASURE\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0"}
                                  {this.getAppContext().platformName() ==
                                  "WiFiProbe"
                                    ? this._countApsNotEnough_ex["-"]
                                      ? Object.keys(this._countApsNotEnough_ex)
                                          .length + " AP "
                                      : Object.keys(this._countApsNotEnough_ex)
                                          .length + " AP"
                                    : null}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}
                                  {"\u00A0"}Details
                                  <span
                                    className={
                                      this.state._advanced_collapse_opened8 ==
                                      false
                                        ? "icon-caret-down-outline"
                                        : "icon-caret-up-outline"
                                    }
                                  ></span>
                                </strong>
                              </div>
                            </div>
                          </div>
                        </Row>
                      </Col>
                    </div>
                  </div>

                  <ReactOCollapse
                    className="border-top border-2"
                    onControllerReady={(_collapse_controller) => {
                      this._advanced_collapse8 = _collapse_controller;
                      this.setState({
                        _advanced_collapse_opened8: false,
                      });
                    }}
                    onOpened={() => {
                      this.setState({ _advanced_collapse_opened8: true });
                    }}
                    onClosed={() => {
                      this.setState({
                        _advanced_collapse_opened8: false,
                      });
                    }}
                    // initOpen={false}
                    initOpen={this.checkOpen("8")}
                  >
                    <ReactOTable
                      thClassName="px-3 py-1"
                      tdClassName="align-middle px-3 py-2"
                      hoverable
                      onRowClick={
                        this.props.onItemClick
                          ? this.props.onItemClick
                          : (row_data) => {
                              // console.log(row_data);
                            }
                      }
                      compressed={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                      }
                      compressedRowRendering={(row_items, link) => {
                        return link ? (
                          <div>
                            <Link
                              className="link-table-test"
                              to={link}
                              target="_blank"
                            >
                              <div className="mt-2">
                                <div className="text-muted">
                                  <small className="">
                                    <strong>{row_items.probe.title}</strong>
                                  </small>
                                </div>
                                {row_items.probe.content}
                              </div>
                              <div className="text-muted">
                                <small className="">
                                  <strong>{row_items.status.title}</strong>
                                </small>
                              </div>
                              {row_items.status.content}
                              <div className="text-muted">
                                <small className="">
                                  <strong>{row_items.since.title}</strong>
                                </small>
                              </div>
                              {row_items.since.content}
                            </Link>
                          </div>
                        ) : (
                          <div>
                            <div className="mt-2">
                              <div className="text-muted">
                                <small className="">
                                  <strong>{row_items.probe.title}</strong>
                                </small>
                              </div>
                              {row_items.probe.content}
                            </div>
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.status.title}</strong>
                              </small>
                            </div>
                            {row_items.status.content}
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.since.title}</strong>
                              </small>
                            </div>
                            {row_items.since.content}
                          </div>
                        );
                      }}
                      thDividers
                      defaultSort={[
                        {
                          data_key: "since",
                          order: "asc",
                        },
                        {
                          data_key: "probe",
                          order: "asc",
                        },
                        {
                          data_key: "status",
                          order: "asc",
                        },
                      ]}
                      cols={[
                        {
                          title: "PROBE",
                          align: "center",
                          data_key: "probe",
                          width: "30",
                          sortable: true,
                        },
                        {
                          title: "MEASURE",
                          align: "center",
                          data_key: "measure",
                          width: "30",
                          sortable: true,
                        },
                        {
                          title: "STATUS",
                          align: "center",
                          data_key: "status",
                          width: "30",
                          sortable: true,
                        },
                        {
                          title: "SINCE",
                          align: "center",
                          data_key: "since",
                          width: "30",
                          sortable: true,
                        },
                      ]}
                      rows={(() => {
                        let _TMP1 = [];
                        this.state.data.online
                          .filter(
                            (m) => m.diag == "N" && m.explicit_mac == "no",
                          )
                          .forEach((_C_row, C_id) => {
                            _TMP1.push({
                              _link: "/" + _C_row.probeid + "/active/",
                              _title: `View active measures for ${_C_row.name}`,
                              probe: {
                                value: _C_row.name,
                                info: _C_row.probeid,
                                render: (
                                  <div>
                                    <div>
                                      <strong> {_C_row.name} </strong>{" "}
                                    </div>
                                    <span className="sub-title">
                                      {" "}
                                      {_C_row.mac}{" "}
                                    </span>
                                  </div>
                                ),
                              },
                              measure: {
                                value: _C_row.name,
                                render: (
                                  <div>
                                    <Link
                                      to={
                                        "/" +
                                        _C_row.probeid +
                                        "/active/" +
                                        _C_row.cssid +
                                        "/" +
                                        (_C_row.bssid != "-"
                                          ? _C_row.bssid.replace(/:/g, "")
                                          : "overal")
                                      }
                                    >
                                      <strong>{_C_row.name}</strong>
                                    </Link>
                                  </div>
                                ),
                              },
                              status: {
                                value: "offline",
                                render: (
                                  <div>
                                    <span
                                      className={
                                        _C_row.last_state == "N" ||
                                        _C_row.last_state == "U"
                                          ? "text-" +
                                            this.getAppContext().conf
                                              .MLY_STATES_DICTIONARY[
                                              _C_row.last_state
                                            ].color
                                          : "text-" + _C_row.color
                                      }
                                    >
                                      {
                                        this.getAppContext().conf
                                          .MLY_STATES_DICTIONARY[_C_row.diag]
                                          .text
                                      }
                                    </span>
                                    {_C_row.step ? (
                                      <div className="sub-title text-danger">
                                        {_C_row.step}
                                      </div>
                                    ) : null}
                                  </div>
                                ),
                              },
                              since: {
                                value: _C_row.since,
                                render: (
                                  <div>
                                    {this.getAppContext()
                                      .momentjs(_C_row.since, "X")
                                      .format("YYYY") < 2014 ? (
                                      "-"
                                    ) : (
                                      <div>
                                        <div>
                                          {this.getAppContext()
                                            .momentjs(_C_row.since, "X")
                                            .format("DD-MM-YYYY")}
                                        </div>
                                        <div className="sub-title">
                                          {this.getAppContext()
                                            .momentjs(_C_row.since, "X")
                                            .format("HH:mm")}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ), // check per date < 2014. Cambiare la regex /([0-9]){4}/g in caso di diversa formattazione dell'anno
                              },
                            });
                          });
                        return _TMP1;
                      })()}
                    ></ReactOTable>
                  </ReactOCollapse>
                </Panel>
              </div>
            )}

          {/* NOT DEPLOYED TABLE */}
          {this.state.data && this.state.data.zzz_not_deployed != 0 ? (
            <div>
              <Panel className="mt-4" bodyClassName="p-0" rounded>
                <div
                  className="notdep-bg"
                  onClick={() => {
                    this._advanced_collapse_np.toggle();
                  }}
                >
                  <div className="py-3">
                    <Col xs={12}>
                      <Row
                        noGutters
                        style={
                          this.getAppContext().media.isMobile
                            ? { display: "block" }
                            : null
                        }
                      >
                        <div className="d-flex flex-grow-1">
                          <div className="flex-grow-1">
                            <h5 className="pt-2">
                              {this.state.data.zzz_not_deployed == 1
                                ? this.state.data.zzz_not_deployed +
                                  " probe not deployed"
                                : this.state.data.zzz_not_deployed +
                                  " probes not deployed"}
                            </h5>
                          </div>

                          <div className="pt-2 justify-content-end">
                            {this.countOfflineProbes(
                              this.state.data.not_deployed,
                            ) > 0 && (
                              <strong>
                                {`Offline: ${this.countOfflineProbes(
                                  this.state.data.not_deployed,
                                )}\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0`}
                              </strong>
                            )}
                            <strong>
                              {this.getAppContext().media.isMobile
                                ? null
                                : "Details "}
                              <span
                                className={
                                  this.state._advanced_collapse_opened_np ==
                                  false
                                    ? "icon-caret-down-outline"
                                    : "icon-caret-up-outline"
                                }
                              ></span>
                            </strong>
                          </div>
                        </div>
                      </Row>
                    </Col>
                  </div>
                </div>

                <ReactOCollapse
                  className="border-top border-2"
                  onControllerReady={(_collapse_controller) => {
                    this._advanced_collapse_np = _collapse_controller;
                    this.setState({ _advanced_collapse_opened_np: false });
                  }}
                  onOpened={() => {
                    this.setState({ _advanced_collapse_opened_np: true });
                  }}
                  onClosed={() => {
                    this.setState({ _advanced_collapse_opened_np: false });
                  }}
                  initOpen={this.checkOpen("6")}
                >
                  <ReactOTable
                    thClassName="px-3 py-1"
                    tdClassName="align-middle px-3 py-2"
                    hoverable
                    compressed={
                      this.getAppContext().media.isMobile ||
                      this.getAppContext().media.isTablet
                    }
                    compressedRowRendering={(row_items, link) => {
                      return link ? (
                        <div>
                          <Link
                            className="link-table-test"
                            to={link}
                            target="_blank"
                          >
                            <div className="mt-2">
                              <div className="text-muted">
                                <small className="">
                                  <strong>{row_items.probe.title}</strong>
                                </small>
                              </div>
                              {row_items.probe.content}
                            </div>
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.status.title}</strong>
                              </small>
                            </div>
                            {row_items.status.content}
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.since.title}</strong>
                              </small>
                            </div>
                            {row_items.since.content}
                          </Link>
                        </div>
                      ) : (
                        <div>
                          <div className="mt-2">
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.probe.title}</strong>
                              </small>
                            </div>
                            {row_items.probe.content}
                          </div>
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.status.title}</strong>
                            </small>
                          </div>
                          {row_items.status.content}
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.since.title}</strong>
                            </small>
                          </div>
                          {row_items.since.content}
                        </div>
                      );
                    }}
                    thDividers
                    defaultSort={[
                      {
                        data_key: "since",
                        order: "asc",
                      },
                      {
                        data_key: "probe",
                        order: "asc",
                      },
                      {
                        data_key: "status",
                        order: "asc",
                      },
                    ]}
                    cols={[
                      {
                        title: "PROBE",
                        align: "center",
                        data_key: "probe",
                        width: "30",
                        sortable: true,
                      },
                      {
                        title: "STATUS",
                        align: "center",
                        data_key: "status",
                        width: "30",
                        sortable: true,
                      },
                      {
                        title: "SINCE",
                        align: "center",
                        data_key: "since",
                        width: "30",
                        sortable: true,
                      },
                    ]}
                    // onRowClick={(row_data) => {
                    //   this.getAppContext().redirectTo(
                    //     "/" + row_data.probe.info.replace(/:/g, "") + "/active/"
                    //   );
                    // }}
                    onRowClick={
                      this.props.onItemClick
                        ? this.props.onItemClick
                        : (row_data) => {
                            // console.log(row_data);
                          }
                    }
                    rows={(() => {
                      let _TMP1 = [];
                      this.state.data.not_deployed.forEach((_C_row, C_id) => {
                        _TMP1.push({
                          _link: "/" + _C_row.probeid + "/active/",
                          _title: `View active measures for ${_C_row.name}`,
                          probe: {
                            value: _C_row.name,
                            info: _C_row.probeid,
                            render: (
                              <div>
                                <strong> {_C_row.name} </strong>
                                <span className="sub-title">
                                  {" "}
                                  {_C_row.mac}{" "}
                                </span>
                              </div>
                            ),
                          },
                          status: {
                            value: _C_row.sync_status,
                            render: (
                              <span>
                                {_C_row.sync_status == 0 ? (
                                  <div>
                                    <span className="text-danger">Offline</span>
                                    {_C_row.step ? (
                                      <div className="sub-title text-danger">
                                        {_C_row.step}
                                      </div>
                                    ) : null}
                                  </div>
                                ) : (
                                  <div>
                                    <span className="text-success">Online</span>
                                    {_C_row.step ? (
                                      <div className="sub-title text-success">
                                        {_C_row.step}
                                      </div>
                                    ) : null}
                                  </div>
                                )}
                              </span>
                            ),
                          },
                          since: {
                            value: _C_row.since,
                            render: (
                              <div>
                                {this.getAppContext()
                                  .momentjs(_C_row.since, "X")
                                  .format("YYYY") < 2014 ? (
                                  "-"
                                ) : (
                                  <div>
                                    <div>
                                      {this.getAppContext()
                                        .momentjs(_C_row.since, "X")
                                        .format("DD-MM-YYYY")}
                                    </div>
                                    <div className="sub-title">
                                      {this.getAppContext()
                                        .momentjs(_C_row.since, "X")
                                        .format("HH:mm")}
                                    </div>
                                  </div>
                                )}
                              </div>
                            ), // check per date < 2014. Cambiare la regex /([0-9]){4}/g in caso di diversa formattazione dell'anno
                          },
                        });
                      });
                      return _TMP1;
                    })()}
                  ></ReactOTable>
                </ReactOCollapse>
              </Panel>
            </div>
          ) : null}
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(
  //	Sites,
  withDefinedContext(DiagView, "Diag", context_exposed_methods),
  {
    retrieve: ["_LayoutSidebar"],
  },
);
